import React from "react";
import styled from "styled-components";
import { formGift } from "config/images";

import { ExchangeConfig } from "config/exchangeConfig";
import { COLOR } from "config/color";

const Wrapper = styled.div`
  width: 100%;
  color: ${COLOR.fontColorPrimary};
  img {
    width: 100%;
  }
  .exchange_content {
    padding: 30px 8vw;
    margin-top: -6px;
    .more {
      text-align: justify;
      font-size: 1.25rem;
      line-height: 160%;
    }
  }
  .gift-card {
    width: 85%;
    margin-bottom: 1rem;
    margin-top: 3rem;
  }
`;

export default function ExchangeContent({ customerForm, stores }) {
  const { phone = "", name = "" } =
    stores.find(({ name }) => name === customerForm.fillinBranch) || {};
  return (
    <Wrapper>
      <img alt="exchange-img" src={ExchangeConfig.banner}></img>
      <img src={formGift} alt="gift card" className="gift-card" />
      <div className="exchange_content">
        <div className="more">
          <div>
            即日起至4月30日止，致電<a href={`tel:${phone}`}>{phone}</a> La
            Prairie萊珀妮{name}
            完成預約，即可憑此兌換頁面，到櫃體驗諮詢，並享有「魚子奢華體驗禮」。(母親節預購會與首四日恕不提供兌換)
          </div>
        </div>
      </div>
    </Wrapper>
  );
}
